module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "maskable_icon_256.6377d83e.png";